import { Controller } from "stimulus"

// Hace polling del estado del procesamiento de la comanda (ProcessComandaJob).
// Mientras el job corre, el botón muestra "Procesando…". Cuando el endpoint
// reporta done/error, recarga la página para mostrar el flash con el resultado
// y los datos actualizados.
export default class extends Controller {
  static values = {
    processing: Boolean,
    statusUrl: String,
    interval: { type: Number, default: 2500 }
  }

  connect() {
    if (this.processingValue) {
      this.poll()
    }
  }

  disconnect() {
    this.stop()
  }

  poll() {
    this.timer = setTimeout(() => this.check(), this.intervalValue)
  }

  check() {
    fetch(this.statusUrlValue, { headers: { Accept: "application/json" } })
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((data) => {
        if (data.status === "processing") {
          this.poll()
        } else {
          // done / error / idle → recargar para mostrar el resultado real
          window.location.reload()
        }
      })
      .catch(() => {
        // Ante un error de red, reintentar en el próximo ciclo
        this.poll()
      })
  }

  stop() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
